import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import "../styles/Sidebar.css";

const Sidebar = ({ menuData }) => {
  const navigate = useNavigate();
  const [openMenus, setOpenMenus] = useState({});

  const toggleMenu = (id) => {
    setOpenMenus((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const renderTree = (nodes) => {
    console.log("🌳 Sidebar menuData:", menuData);

    if (!Array.isArray(nodes)) {
      console.warn("🚨 renderTree received NON-ARRAY:", nodes);
      return null;
    }

    return (
      <ul>
        {nodes.map((node) => {
          const hasChildren =
            Array.isArray(node.children) && node.children.length > 0;
          const isPage = node.isPage === true;
          const isOpen = openMenus[node.id] || false;

          return (
            <li key={node.id}>
              <div
                className={`menu-item ${isOpen ? "open" : ""}`}
                onClick={() => {
                  if (hasChildren) toggleMenu(node.id);
                  else if (isPage) navigate(`/${node.url}`); // FIXED
                }}
              >
                {hasChildren && (
                  <span className="menu-arrow">
                    {isOpen ? <FaChevronDown /> : <FaChevronRight />}
                  </span>
                )}

                <span className="menu-text">{node.name}</span>
              </div>

              {hasChildren && isOpen && (
                <div className="submenu">{renderTree(node.children)}</div>
              )}
            </li>
          );
        })}
      </ul>
    );
  };

  return <aside className="sidebar">{renderTree(menuData)}</aside>;
};

export default Sidebar;
